import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { StudentWorkspaceLayout } from "@/components/layout/StudentWorkspaceLayout";
import { LoginPage } from "@/pages/LoginPage";
import { StudentsPage } from "@/pages/StudentsPage";
import { StudentDetailPage } from "@/pages/StudentDetailPage";
import { AssessmentsLandingPage } from "@/pages/AssessmentsLandingPage";
import { ScaleLibraryPage } from "@/pages/ScaleLibraryPage";
import { ScaleEvaluationPage } from "@/pages/ScaleEvaluationPage";
import { ActivityAssessmentPage } from "@/pages/ActivityAssessmentPage";
import { ReportsListPage } from "@/pages/ReportsListPage";
import { ReportDetailPage } from "@/pages/ReportDetailPage";
import { ReportsComparePage } from "@/pages/ReportsComparePage";
import { IEPReportPage } from "@/pages/IEPReportPage";
import { ParentReportPage } from "@/pages/ParentReportPage";
import { ReportsAnalyticsPage } from "@/pages/ReportsAnalyticsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { AccountsPage } from "@/pages/AccountsPage";
import { useAuth } from "@/providers/AuthProvider";
import { studentWorkspacePaths } from "@/utils/student-workspace";

export function AppRouter(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/children" replace />} />
          <Route path="children">
            <Route index element={<StudentsPage />} />
            <Route path=":studentId" element={<StudentWorkspaceLayout />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<StudentDetailPage />} />
              <Route path="assessments">
                <Route index element={<AssessmentsLandingPage />} />
                <Route path="scale" element={<ScaleEvaluationPage />} />
                <Route path="activity" element={<ActivityAssessmentPage />} />
              </Route>
              <Route path="reports">
                <Route index element={<ReportsListPage />} />
                <Route path="assessment/:assessmentId" element={<ReportDetailPage />} />
                <Route path="analytics" element={<ReportsAnalyticsPage />} />
                <Route path="compare" element={<ReportsComparePage />} />
                <Route path="parent" element={<LegacyParentReportRedirect />} />
              </Route>
              <Route path="parent" element={<ParentReportPage />} />
              <Route path="iep" element={<IEPReportPage />} />
            </Route>
          </Route>
          <Route path="scale" element={<ScaleLibraryPage />} />
          <Route path="accounts" element={<SuperAdminRoute />} />
          <Route path="home" element={<Navigate to="/children" replace />} />
          <Route path="students/*" element={<Navigate to="/children" replace />} />
          <Route
            path="assessments/*"
            element={
              <Navigate
                to="/children"
                replace
                state={{ notice: "请先选择儿童，再开始或继续评估。" }}
              />
            }
          />
          <Route
            path="reports/*"
            element={
              <Navigate
                to="/children"
                replace
                state={{ notice: "请先选择儿童，再查看对应的报告。" }}
              />
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function SuperAdminRoute(): JSX.Element {
  const { user } = useAuth();
  return user?.isSuperAdmin ? <AccountsPage /> : <Navigate to="/children" replace />;
}

function LegacyParentReportRedirect(): JSX.Element {
  const { studentId = "" } = useParams<{ studentId: string }>();
  const { search } = useLocation();
  return <Navigate to={`${studentWorkspacePaths.parentReport(studentId)}${search}`} replace />;
}
